var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.688A7.312 7.312 0 1016.313 9 7.32 7.32 0 009 1.687zm0 13.5A6.187 6.187 0 1115.188 9 6.195 6.195 0 019 15.188zm2.185-3.253a.562.562 0 01-.76.234 3.008 3.008 0 00-2.85 0 .562.562 0 01-.525-.994 4.172 4.172 0 013.9 0 .562.562 0 01.235.76zm2.25-3.938a.563.563 0 01-.762.232 7.778 7.778 0 00-7.345 0 .563.563 0 11-.53-.993 8.906 8.906 0 018.405 0 .563.563 0 01.23.763l.002-.002zm-1.125 1.97a.563.563 0 01-.761.231 5.414 5.414 0 00-5.096 0 .563.563 0 01-.53-.993 6.54 6.54 0 016.155 0 .563.563 0 01.273.333c.022.071.03.146.022.22a.562.562 0 01-.064.21v-.002z"
  })));
}
export default SvgSpotify;